module.exports = __webpack_public_path__ + "static/img/yulantupian.6a5f47b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right/classAlbum/yulantupian.png
// module id = 2CgD
// module chunks = 1